module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "persistent": "",
      "scrollable": "",
      "fullscreen": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "card-title-background"
  }, [_vm._v("\n      Edit Content Storyboard\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "background": "#cccccc"
    }
  }, [_c('creator-concept-form', {
    attrs: {
      "mode": "edit",
      "editData": _vm.editData,
      "value": _vm.value
    },
    on: {
      "updatedContentScript": _vm.handleUpdatedContentScript
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89dd22b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Pairing/CreatorConcept/ViewModalDialog.vue
// module id = 2232
// module chunks = 0